/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import InlineEditorBase from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Font from '@ckeditor/ckeditor5-font/src/font';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
// import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Placeholder from './plugins/placeholder';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';

// Amply custom plugins
import Button from './plugins/button';
import ImageUploadAdapter from './plugins/imageuploadadapter';
import AmplyOverrides from './plugins/amplyoverrides';
import AmplyFontColor from './plugins/amplyfontcolor';

export default class InlineEditor extends InlineEditorBase {}

// Plugins to include in the build.
InlineEditor.builtinPlugins = [
  AmplyOverrides,
  Essentials,
  UploadAdapter,
  Button,
  Autoformat,
  Bold,
  Underline,
  Font,
  Italic,
  BlockQuote,
  CKFinder,
  EasyImage,
  Heading,
  HtmlEmbed,
  Image,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  ImageUploadAdapter,
  ImageResize,
  Indent,
  Link,
  List,
  // MediaEmbed,
  Paragraph,
  PasteFromOffice,
  Placeholder,
  RemoveFormat,
  AmplyFontColor,
  CloudServices,
  // Table,
  // TableToolbar
];

// Editor configuration.
InlineEditor.defaultConfig = {
  toolbar: {
    items: [
//      'heading',
//      '|',
      // 'fontSize',
//      'fontFamily',
//      'fontColor',
      'bold',
      'italic',
      'underline',
      'amplyFontColor',
      'removeFormat',
      '|',
      'link',
      '|',
      'bulletedList',
      'numberedList',
//      '|',
//      'alignment',
      // 'indent',
      // 'outdent',
      '|',
      'imageUpload',
      'button',
      'htmlEmbed',
      '|',
      // 'blockQuote',
//      'placeholder',
      // 'insertTable',
      // 'mediaEmbed',
      'undo',
      'redo'
    ]
  },
  image: {
    toolbar: [
      'imageStyle:full',
      'imageStyle:side',
      '|',
      'imageTextAlternative'
    ]
  },
  // table: {
  //   contentToolbar: [
  //     'tableColumn',
  //     'tableRow',
  //     'mergeTableCells'
  //   ]
  // },
  // This value must be kept in sync with the language defined in webpack.config.js.
  language: 'en'
};
